import React, { Component } from 'react';
import {baseUrl} from '../../url';
import moment from 'moment';

class AFBTest extends Component{
    constructor(){
        super()
        this.state = {
            type: 'afb',
            date: '',
            macroscopy: '',
            result: '',
            grading: '',
            actual_no: '',
            response: true,
            success: false,
        }
    }

    handleChange = (e) => {
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });
        
        if(e.target.name === 'actual_no' && e.target.value > 100){
            this.setState({
                actual_noError: 'Value should not be greater than 100'
            })
        }

        if(e.target.name === 'date'){
            let date  = moment(e.target.value).format('YYYY-MM-DD HH:mm:ss')
            this.setState({
                date
            })
        }
    }
    close = () => {
        setTimeout(() => { 
            this.props.handleClose();
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {type, date , macroscopy, result, grading, actual_no, dateError, macroscopyError, resultError, gradingError, actual_noError} = this.state;

        if(!date){
            this.setState({
                dateError: 'Please enter a valid date'
            })
        }
        if(!macroscopy){
            this.setState({
                macroscopyError: 'This field cannot be empty'
            })
        }
        if(!result){
            this.setState({
                resultError: 'This field cannot be empty'
            })
        }
        if(result === 'positive'){
            if(!grading){
                this.setState({
                    gradingError: 'This field cannot be empty'
                })
            }
            if(grading ===  'scanty'){
                if(!actual_no){
                    this.setState({
                        actual_noError: 'This field cannot be empty'
                    })
                }
            }
        }
        if(date && macroscopy && result && !dateError && !macroscopyError && !resultError && !gradingError && !actual_noError){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            const id = localStorage.getItem('user_id');
            let retries = 0;
            let entry = {
                'type': type,
                'treatment_date': date,
                'macroscopy': macroscopy,
                'result': result
            };
            if(result === 'positive'){
                entry = {
                    ...entry,
                    'grading':grading
                }
                if(grading && grading === 'scanty'){
                    entry = {
                        ...entry,
                        'actual_no': actual_no
                    }
                }
            };
            fetch(`${baseUrl}/admin/patients/tests/${id}`,{
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       }, () => {
                           this.props.hideField();
                           this.props.refresh();
                           this.close();
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        const state = this.state;
        return(
            <React.Fragment>
                {
                    !this.state.success && 
                    <React.Fragment>
                        <label>
                            Date test was taken
                            <input type="date" onChange={this.handleChange} name="date" className={this.state.dateError ? 'error-input' : ''} />
                            <span className="error-text">{this.state.dateError}</span>
                        </label>
                        <label>
                            Macroscopy
                            <select onChange={this.handleChange} name="macroscopy" className={this.state.macroscopyError ? 'error-input' : ''}>
                                <option>Select...</option>
                                <option value="salivary">Salivary (S)</option>
                                <option value="mucoid">Mucoid (M)</option>
                                <option value="muco-purulent">Muco-purulent (MP)</option>
                                <option value="bloody">Bloody (B)</option>
                                <option value="purulent">Purulent (P)</option>
                                <option value="muco-salivary">Muco-salivary (MS)</option>
                            </select>
                            <span className="error-text">{this.state.macroscopyError}</span>
                        </label>
                        <label>
                            Result
                            <select onChange={this.handleChange} name="result" className={this.state.resultError ? 'error-input' : ''}>
                                <option>Select...</option>
                                <option value="positive">Positive</option>
                                <option value="negative">Negative</option>
                            </select>
                            <span className="error-text">{this.state.resultError}</span>
                        </label>
                        {
                            state.result === 'positive' &&
                            <div>
                                <label>
                                    Grading
                                    <select onChange={this.handleChange} name="grading" className={this.state.gradingError ? 'error-input' : ''}>
                                        <option>Select...</option>
                                        <option value="scanty">Scanty</option>
                                        <option value="1+">1+</option>
                                        <option value="2+">2+</option>
                                        <option value="3+">3+</option>
                                    </select>
                                    <span className="error-text">{this.state.gradingError}</span>
                                </label>
                            </div>
                        }
                        {
                            state.grading === 'scanty' && state.result === 'positive' &&
                            <div>
                                <label>
                                    Actual No
                                    <input type="number" onChange={this.handleChange} name="actual_no" className={this.state.actual_noError ? 'error-input' : ''} />
                                    <span>/100</span>
                                    <span className="error-text">{this.state.actual_noError}</span>
                                </label>
                            </div>
                        }
                        <button onClick={this.handleSubmit}>
                            Save
                            {
                                !this.state.response &&
                                <i className="fa fa-spinner fa-pulse fa-fw" />
                            }
                        </button>
                    </React.Fragment>
                }
                {
                    this.state.success &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </div>
                        <p><small>{this.state.message}</small></p>
                    </div> 
                }
            </React.Fragment>
        )
    }
}

export default AFBTest;


// WEBPACK FOOTER //
// ./src/components/patientProfile/testForms/afb.js